import { useIsAuthenticated as useIsAuthenticatedAzure } from '@azure/msal-react';

const useIsAuthenticated = () => {
  const isAuthenticated = useIsAuthenticatedAzure();

  return isAuthenticated;
};

export default useIsAuthenticated;
